var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvgPerfil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svg-perfil",
    transform: "translate(-1607 -57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "form",
    transform: "translate(1607 57)",
    fill: "none",
    stroke: "#73a91b",
    strokeLinejoin: "round",
    strokeWidth: 2,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 48,
    height: 48,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Form_563_Kopie",
    "data-name": "Form 563 Kopie",
    d: "M8.1,24.012,7.605,24a3.35,3.35,0,0,1-.543-.068,17.163,17.163,0,0,1-2.716-.393l-.295-.059C2.137,23.054.93,22.274.358,21.09A3.769,3.769,0,0,1,0,19.492a3.69,3.69,0,0,1,.365-1.61c.593-1.188,1.961-2.034,3.961-2.444A19.833,19.833,0,0,1,7.1,15.044a29.111,29.111,0,0,1,5.137,0l.539.046a19.9,19.9,0,0,1,2.231.348c2.122.437,3.384,1.219,3.973,2.461a3.72,3.72,0,0,1,0,3.19c-.587,1.238-1.883,2.039-3.965,2.45l-.544.114a19,19,0,0,1-2.241.291c-.852.073-1.705.109-2.551.109C9.152,24.053,8.624,24.04,8.1,24.012Zm-.817-6.69a17.627,17.627,0,0,0-2.492.354,3.627,3.627,0,0,0-2.385,1.215,1.372,1.372,0,0,0-.133.6,1.44,1.44,0,0,0,.135.613c.252.522,1.105.951,2.4,1.2l.418.089a18.5,18.5,0,0,0,2.159.287,2.272,2.272,0,0,0,.329.037l.451.01a28.481,28.481,0,0,0,3.888-.061,16.476,16.476,0,0,0,2.495-.364l.268-.057c1.131-.257,1.88-.662,2.107-1.14a1.427,1.427,0,0,0,0-1.226c-.243-.511-1.088-.94-2.383-1.205a17.6,17.6,0,0,0-2.484-.354h-.02c-.783-.069-1.575-.1-2.367-.1S8.079,17.252,7.285,17.321ZM3.156,6.554a6.52,6.52,0,1,1,6.521,6.552A6.544,6.544,0,0,1,3.156,6.554Zm2.276,0A4.245,4.245,0,1,0,9.677,2.285,4.262,4.262,0,0,0,5.431,6.554Z",
    transform: "translate(1622.068 69.994)",
    fill: "#73a91b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgPerfil);
export default __webpack_public_path__ + "static/media/svg-perfil.9fd54ec3e42b1cf2095370c3dbcf7378.svg";
export { ForwardRef as ReactComponent };